import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import { translateKey } from '../../../../../translate';
import { FormParagraph, UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function TccrV1DiagnosticReportSummary(props: ICustomControlDiagnosticReportReadProps) {
    if (!props.diagnosticReport.customControlData) {
        return null;
    }

    return (
        <>
            {props.diagnosticReport.customControlData.conclusie && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosticReport.findings')}</FormLabel>
                    <InputContainer>
                        <FormParagraph>{props.diagnosticReport.customControlData.conclusie}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.diagnosticReport.customControlData.bezoek_specialist_nodig && (
                <HorizontalFormGroupRead>
                    <FormLabel>Bezoek aan specialist nodig?</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {props.diagnosticReport.customControlData.bezoek_specialist_nodig}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.diagnosticReport.customControlData.advies && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosticReport.policy')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.diagnosticReport.customControlData.advies}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
